import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import * as s from "./index.module.scss";
import Location from "../Common/Location";
import ContactVector from "../../images/ContactUs/contact.svg";
import WorkingHours from "./WorkingHours";
import Form from "../Common/Form/FormTabs";
import { PrismicRichText } from "@prismicio/react";

const Contact = ({ caption = "", title = "", description, working = {} }) => {
  return (
    <section className={`section-center ${s.contact_us}`}>
      <div className={s.header}>
        <h5 className="fw-normal">{caption}</h5>
        <h1 className="heading">{title}</h1>
        <div>
          <PrismicRichText field={description || []} />
        </div>
        <div className={s.contact_vector}>
          <img loading="lazy" src={ContactVector.src} alt="image" />
        </div>
      </div>
      <div className={s.map}>
        <Location />
      </div>
      <Container>
        <Row className="justify-content-xxl-start">
          <Col xs={12} md={6} lg={7} xxl={6}>
            <WorkingHours data={working} />
          </Col>
          <Col xs={12} md={6} lg={5} xxl={4} className={s.form}>
            <Form page={"Contact Us"} />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Contact;
